import { createFileRoute, notFound } from "@tanstack/react-router";

import { workspaceProfileFilesQueries } from "@/api/resources/workspaceProfileFiles/queries";
import { workspaceProfilesQueries } from "@/api/resources/workspaceProfiles/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import WorkspaceSettingsPage from "@/components/Workspace/WorkspaceSettingsPage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/settings/details")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.workspace-settings"),
        icon: <Icon.SETTINGS />,
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    const workspaceProfile = await context.queryClient.ensureQueryData(workspaceProfilesQueries.byId(workspace_id));
    if (!workspaceProfile) throw notFound();
    await context.queryClient.ensureQueryData(workspaceProfileFilesQueries.byId(workspace_id));
  },
  component: WorkspaceSettingsPage,
});
